// Global variables are defined and set here

declare global {
  /** Defines empty value to be passed to api clients (generated from Open API) methods.
   *  This value is overwritten by global config in ApiClient.ts.
   */
  var EMPTY_TENANT_IDENTIFIER: string;
}

global.EMPTY_TENANT_IDENTIFIER = "";

export {};
